document.addEventListener("DOMContentLoaded", () => {
  let pageUrl = "https://www.bilsteinsuspensionstore.co.uk/pages/search";

  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  function capitalizeWords(str) {
    return str.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase();
    });
  }

  let domProducts = [];

  let manufacturerSelect = document.querySelector("#manufacturer");
  let yearSelect = document.querySelector("#year");
  let modelSelect = document.querySelector("#model");
  let engineSelect = document.querySelector("#engine");

  let skuSelect = document.querySelector("#sku");
  let productInfo = document.querySelector("#appProductWrapper");
  let filterResetBtn = document.querySelector(".filterReset");
  let filterQueryData;
  let productDefinedPositions = [];
  let productDefinedRanges = [];
  let filterChips = document.querySelector(".currentFilter");

  let manufacturer = getQueryParam("manufacturer");
  let year = getQueryParam("year");
  let model = getQueryParam("model");
  let engine = getQueryParam("engine");

  function updateURL() {
    const manufacturer = manufacturerSelect.value || "";
    const year = yearSelect.value || "";
    const model = modelSelect.value || "";
    const engine = engineSelect.value || "";

    const url = new URL(window.location.href);

    url.searchParams.set("manufacturer", manufacturer);
    url.searchParams.set("year", year);
    url.searchParams.set("model", model);
    url.searchParams.set("engine", engine);

    Array.from(url.searchParams.entries()).forEach(([key, value]) => {
      if (!value) url.searchParams.delete(key);
    });

    window.history.pushState({ path: url.href }, "", url.href);
  }

  function fetchManufacturer() {
    const listPromise = fetch(`/apps/bilstein-search-v2/csv-data-manufacturer`)
      .then((response) => response.json())
      .then((csvData) => {
        csvData.sort((a, b) => a.manufacturer.localeCompare(b.manufacturer));
        csvData.forEach((product) => {
          const option = document.createElement("option");
          option.value = product.manufacturer;
          option.textContent = product.manufacturer.toUpperCase();
          manufacturerSelect && manufacturerSelect.appendChild(option);
        });
      })
      .catch((error) => console.error("Error fetching manufacturer:", error));

    // When the page loads with URL params, every dropdown level is already
    // known, so fetch them all concurrently instead of chaining one round-trip
    // after another. Values are assigned once each select is populated.
    if (manufacturer) {
      Promise.all([
        listPromise,
        fetchYears(manufacturer),
        year ? fetchModels(manufacturer, year) : Promise.resolve(),
        year && model
          ? fetchEngine(manufacturer, year, model)
          : Promise.resolve(),
      ]).then(() => {
        manufacturerSelect.value = manufacturer;
        if (year) yearSelect.value = year;
        if (model) modelSelect.value = model;
        if (engine) engineSelect.value = engine;
      });
    }
  }

  fetchManufacturer();

  // Function to fetch years based on the selected model
  function fetchYears(selectedManufacturer, callback) {
    if (!selectedManufacturer) return Promise.resolve();

    return fetch(
      `/apps/bilstein-search-v2/csv-data-years?manufacturer=${selectedManufacturer}`
    )
      .then((response) => response.json())
      .then((years) => {
        const allYears = years.flatMap((item) => item.year);
        const uniqueYearsSet = new Set(allYears);
        const uniqueYears = Array.from(uniqueYearsSet).sort((a, b) => b - a);
        yearSelect.innerHTML =
          '<option value="" disabled selected>Select Year</option>';
        uniqueYears.forEach((year) => {
          const option = document.createElement("option");
          option.value = year;
          option.textContent = year;
          yearSelect.appendChild(option);
        });
        yearSelect.nextElementSibling.classList.add("hidden");
        if (callback) callback();
      })
      .catch((error) => console.error("Error fetching years:", error));
  }

  // Function to fetch models based on the selected manufacturer
  function fetchModels(selectedManufacturer, selectedYear, callback) {
    if (!selectedYear) return Promise.resolve();

    return fetch(
      `/apps/bilstein-search-v2/csv-data-models?manufacturer=${selectedManufacturer}&year=${selectedYear}`
    )
      .then((response) => response.json())
      .then((models) => {
        models.sort((a, b) => a.localeCompare(b));
        modelSelect.innerHTML =
          '<option value="" disabled selected>Select Model</option>';
        models.forEach((modelOption) => {
          const option = document.createElement("option");
          option.value = modelOption;
          option.textContent = modelOption.toUpperCase();
          modelSelect.appendChild(option);
        });
        modelSelect.nextElementSibling.classList.add("hidden");
        if (callback) callback();
      })
      .catch((error) => console.error("Error fetching models:", error));
  }

  // Function to fetch engine types based on the selected model
  function fetchEngine(
    selectedManufacturer,
    selectedYear,
    selectedModel,
    callback
  ) {
    if (!selectedModel) return Promise.resolve();

    return fetch(
      `/apps/bilstein-search-v2/csv-data-engine?manufacturer=${selectedManufacturer}&year=${selectedYear}&model=${selectedModel}`
    )
      .then((response) => response.json())
      .then((engineTypes) => {
        engineSelect.innerHTML =
          '<option value="" disabled selected>Select Engine</option>';
        engineTypes.forEach((engineType) => {
          const option = document.createElement("option");
          option.value = engineType.engine;
          option.textContent = capitalizeWords(engineType.engine);
          engineSelect.appendChild(option);
        });
        engineSelect.nextElementSibling.classList.add("hidden");
        if (callback) callback();
      })
      .catch((error) => console.error("Error fetching engine:", error));
  }

  // Event listener for changes in the "manufacturer" dropdown
  manufacturerSelect &&
    manufacturerSelect.addEventListener("change", () => {
      if (productInfo) {
        productInfo.innerHTML = "";
      }
      yearSelect.value = "";
      modelSelect.value = "";
      modelSelect.innerHTML =
        '<option value="" disabled selected>Select Model</option>';
      engineSelect.value = "";
      engineSelect.innerHTML =
        '<option value="" disabled selected>Select Engine</option>';
      yearSelect.nextElementSibling.classList.remove("hidden");
      fetchYears(manufacturerSelect.value);
      updateURL();
      if (productInfo) {
        productInfo.classList.remove("noProductFound");
      }
    });

  // Event listener for changes in the "Year" dropdown
  yearSelect &&
    yearSelect.addEventListener("change", () => {
      if (yearSelect.value != "") {
        if (productInfo) {
          productInfo.innerHTML = "";
        }
        modelSelect.value = "";
        engineSelect.value = "";
        engineSelect.innerHTML =
          '<option value="" disabled selected>Select Engine</option>';

        modelSelect.nextElementSibling.classList.remove("hidden");
        fetchModels(manufacturerSelect.value, yearSelect.value);
        updateURL();
        if (productInfo) {
          productInfo.classList.remove("noProductFound");
        }
      }
    });

  // Event listener for changes in the "Model" dropdown
  modelSelect &&
    modelSelect.addEventListener("change", () => {
      if (productInfo) {
        productInfo.innerHTML = "";
      }
      engineSelect.value = "";
      engineSelect.innerHTML =
        '<option value="" disabled selected>Select Engine</option>';

      engineSelect.nextElementSibling.classList.remove("hidden");
      fetchEngine(
        manufacturerSelect.value,
        yearSelect.value,
        modelSelect.value
      );
      updateURL();
      if (productInfo) {
        productInfo.classList.remove("noProductFound");
      }
    });

  // Event listener for changes in the "engine" dropdown
  engineSelect &&
    engineSelect.addEventListener("change", () => {
      if (productInfo) {
        productInfo.innerHTML = "";
      }
      updateURL();
      if (productInfo) {
        productInfo.classList.remove("noProductFound");
      }
    });

  // filter reset button
  if (filterResetBtn) {
    filterResetBtn.addEventListener("click", (event) => {
      // Reset select elements
      event.preventDefault();
      manufacturerSelect.innerHTML =
        '<option value="" selected>Select manufacturer</option>';
      yearSelect.innerHTML = '<option value="" selected>Select Year</option>';
      modelSelect.innerHTML = '<option value="" selected>Select Model</option>';
      engineSelect.innerHTML =
        '<option value="" selected>Select Engine</option>';
      manufacturer = "";
      model = "";
      year = "";
      engine = "";
      if (productInfo) {
        productInfo.innerHTML = "";
        productInfo.classList.remove("noProductFound");
      }
      fetchManufacturer();
      updateURL();
      $(".filterOptionContent").removeClass("open").slideUp();
      $(".filterOptionContent").html("");
      if (filterChips) {
        filterChips.innerHTML = "";
      }
      let filterClass = document.querySelector(".customFilter");
      filterClass.classList.remove("data-in");
      showProducts();
    });
  }

  // widget button
  const form = document.getElementById("ebc-product-search");
  if (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      const urlParams = new URL(window.location).searchParams;
      const manufacturer = urlParams.get("manufacturer");
      const year = urlParams.get("year");
      const model = urlParams.get("model");
      const engine = urlParams.get("engine");
      const baseUrl = pageUrl;
      const queryString = `?manufacturer=${encodeURIComponent(
        manufacturer
      )}&year=${encodeURIComponent(year)}&model=${encodeURIComponent(
        model
      )}&engine=${encodeURIComponent(engine)}`;
      window.location.href = baseUrl + queryString;
    });
  }

  // product card html
  function productCard(sku, product, query, productDefinedPositions, productDefinedRanges) {
    let tags = product.tags[0].split(",").map((code) => code.trim());
    let productPosition = productDefinedPositions
      .filter((item) => tags.includes(item))
      .join(", ");
    let productRange = productDefinedRanges
      .filter((item) => tags.includes(item))
      .join(", ");
    let quantityDropdownValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    let variant = product.variants.find((variant) => variant.sku === sku);
    // Conditional Stock Info
    let stockInfoHTML = '';
    if(variant.inventory_management){
      stockInfoHTML = variant.inventory_quantity > 0
        ? `<img style="width:22px;" src="https://cdn.shopify.com/s/files/1/0673/3683/1274/files/check_1_2x_5ccff06c-2027-4340-8ee9-bd795d9091d7.png?v=1730206123">
              <span>${variant.inventory_quantity} In stock</span>`
        : `<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#009CDE"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16.1007 13.359L15.5719 12.8272H15.5719L16.1007 13.359ZM16.5562 12.9062L17.085 13.438H17.085L16.5562 12.9062ZM18.9728 12.5894L18.6146 13.2483L18.9728 12.5894ZM20.8833 13.628L20.5251 14.2869L20.8833 13.628ZM21.4217 16.883L21.9505 17.4148L21.4217 16.883ZM20.0011 18.2954L19.4723 17.7636L20.0011 18.2954ZM18.6763 18.9651L18.7459 19.7119H18.7459L18.6763 18.9651ZM8.81536 14.7266L9.34418 14.1947L8.81536 14.7266ZM4.00289 5.74561L3.2541 5.78816L3.2541 5.78816L4.00289 5.74561ZM10.4775 7.19738L11.0063 7.72922H11.0063L10.4775 7.19738ZM10.6342 4.54348L11.2346 4.09401L10.6342 4.54348ZM9.37326 2.85908L8.77286 3.30855V3.30855L9.37326 2.85908ZM6.26145 2.57483L6.79027 3.10667H6.79027L6.26145 2.57483ZM4.69185 4.13552L4.16303 3.60368H4.16303L4.69185 4.13552ZM12.0631 11.4972L12.5919 10.9654L12.0631 11.4972ZM16.6295 13.8909L17.085 13.438L16.0273 12.3743L15.5719 12.8272L16.6295 13.8909ZM18.6146 13.2483L20.5251 14.2869L21.2415 12.9691L19.331 11.9305L18.6146 13.2483ZM20.8929 16.3511L19.4723 17.7636L20.5299 18.8273L21.9505 17.4148L20.8929 16.3511ZM18.6067 18.2184C17.1568 18.3535 13.4056 18.2331 9.34418 14.1947L8.28654 15.2584C12.7186 19.6653 16.9369 19.8805 18.7459 19.7119L18.6067 18.2184ZM9.34418 14.1947C5.4728 10.3453 4.83151 7.10765 4.75168 5.70305L3.2541 5.78816C3.35456 7.55599 4.14863 11.144 8.28654 15.2584L9.34418 14.1947ZM10.7195 8.01441L11.0063 7.72922L9.9487 6.66555L9.66189 6.95073L10.7195 8.01441ZM11.2346 4.09401L9.97365 2.40961L8.77286 3.30855L10.0338 4.99296L11.2346 4.09401ZM5.73263 2.04299L4.16303 3.60368L5.22067 4.66736L6.79027 3.10667L5.73263 2.04299ZM10.1907 7.48257C9.66189 6.95073 9.66117 6.95144 9.66045 6.95216C9.66021 6.9524 9.65949 6.95313 9.659 6.95362C9.65802 6.95461 9.65702 6.95561 9.65601 6.95664C9.65398 6.95871 9.65188 6.96086 9.64972 6.9631C9.64539 6.96759 9.64081 6.97245 9.63599 6.97769C9.62634 6.98816 9.61575 7.00014 9.60441 7.01367C9.58174 7.04072 9.55605 7.07403 9.52905 7.11388C9.47492 7.19377 9.41594 7.2994 9.36589 7.43224C9.26376 7.70329 9.20901 8.0606 9.27765 8.50305C9.41189 9.36833 10.0078 10.5113 11.5343 12.0291L12.5919 10.9654C11.1634 9.54499 10.8231 8.68059 10.7599 8.27309C10.7298 8.07916 10.761 7.98371 10.7696 7.96111C10.7748 7.94713 10.7773 7.9457 10.7709 7.95525C10.7677 7.95992 10.7624 7.96723 10.7541 7.97708C10.75 7.98201 10.7451 7.98759 10.7394 7.99381C10.7365 7.99692 10.7335 8.00019 10.7301 8.00362C10.7285 8.00534 10.7268 8.00709 10.725 8.00889C10.7241 8.00979 10.7232 8.0107 10.7223 8.01162C10.7219 8.01208 10.7212 8.01278 10.7209 8.01301C10.7202 8.01371 10.7195 8.01441 10.1907 7.48257ZM11.5343 12.0291C13.0613 13.5474 14.2096 14.1383 15.0763 14.2713C15.5192 14.3392 15.8763 14.285 16.1472 14.1841C16.28 14.1346 16.3858 14.0763 16.4658 14.0227C16.5058 13.9959 16.5392 13.9704 16.5663 13.9479C16.5799 13.9367 16.5919 13.9262 16.6024 13.9166C16.6077 13.9118 16.6126 13.9073 16.6171 13.903C16.6194 13.9008 16.6215 13.8987 16.6236 13.8967C16.6246 13.8957 16.6256 13.8947 16.6266 13.8937C16.6271 13.8932 16.6279 13.8925 16.6281 13.8923C16.6288 13.8916 16.6295 13.8909 16.1007 13.359C15.5719 12.8272 15.5726 12.8265 15.5733 12.8258C15.5735 12.8256 15.5742 12.8249 15.5747 12.8244C15.5756 12.8235 15.5765 12.8226 15.5774 12.8217C15.5793 12.82 15.581 12.8183 15.5827 12.8166C15.5862 12.8133 15.5895 12.8103 15.5926 12.8074C15.5988 12.8018 15.6044 12.7969 15.6094 12.7929C15.6192 12.7847 15.6265 12.7795 15.631 12.7764C15.6403 12.7702 15.6384 12.773 15.6236 12.7785C15.5991 12.7876 15.501 12.8189 15.3038 12.7886C14.8905 12.7253 14.02 12.3853 12.5919 10.9654L11.5343 12.0291ZM9.97365 2.40961C8.95434 1.04802 6.94996 0.83257 5.73263 2.04299L6.79027 3.10667C7.32195 2.578 8.26623 2.63181 8.77286 3.30855L9.97365 2.40961ZM4.75168 5.70305C4.73201 5.35694 4.89075 4.9954 5.22067 4.66736L4.16303 3.60368C3.62571 4.13795 3.20329 4.89425 3.2541 5.78816L4.75168 5.70305ZM19.4723 17.7636C19.1975 18.0369 18.9029 18.1908 18.6067 18.2184L18.7459 19.7119C19.4805 19.6434 20.0824 19.2723 20.5299 18.8273L19.4723 17.7636ZM11.0063 7.72922C11.9908 6.7503 12.064 5.2019 11.2346 4.09401L10.0338 4.99295C10.4373 5.53193 10.3773 6.23938 9.9487 6.66555L11.0063 7.72922ZM20.5251 14.2869C21.3429 14.7315 21.4703 15.7769 20.8929 16.3511L21.9505 17.4148C23.2908 16.0821 22.8775 13.8584 21.2415 12.9691L20.5251 14.2869ZM17.085 13.438C17.469 13.0562 18.0871 12.9616 18.6146 13.2483L19.331 11.9305C18.2474 11.3414 16.9026 11.5041 16.0273 12.3743L17.085 13.438Z" fill="#009CDE"></path> </g></svg>
              <span class="callForAvail"><a href="/pages/contact" style="color:inherit;" target="blank">Call for availability</a></span>`;
    }

    // Conditional Add-to-Cart Button
    let addToCartButtonHTML = '';
    if(variant.inventory_management){
      addToCartButtonHTML = variant.inventory_quantity > 0
        ? `<button onclick="addToCart(${variant.id},event)">ADD TO BASKET</button>`
        : variant.inventory_policy === "deny"
        ? `<button>OUT OF STOCK</button>`
        : `<button class="preOrderBtn" onclick="addToCart(${variant.id},event)">PRE-ORDER</button>`;
    }else{
      addToCartButtonHTML = `<button onclick="addToCart(${variant.id},event)">ADD TO BASKET</button>`
    }

    const productHTML = `
           <div class="appProduct">
               <div class="productCardBadgeBox">
                 ${
                   productPosition
                     ? `<p class='positionBadge'>${productPosition}</p>`
                     : ""
                 }
                 ${
                   productRange
                     ? `<p class='rangeBadge'>${productRange}</p>`
                     : ""
                 }
               </div>
               <div class="product-sku-img-row">
                   <div class="productImgWrapper">
                     <a href='/products/${product.handle}' target="blank">
                       <img
                           src="${product.image_src}"
                           style="width:100%"
                           class="pFirstImage"
                       >
                       ${
                         product.images[1]
                           ? `<img src="${product.images[1].src}" style="width:100%" class="pSecondImage">`
                           : ""
                       }
                   </div>
                   <a href='/products/${
                     product.handle
                   }' target="blank"><p class="partNo">Part No   <strong>${
      variant.sku
    }</strong></p></a>
                   <a href='/products/${
                     product.handle
                   }' target="blank"><p class="partNo"><p class="productTitle">${
      product.title
    }</p></a>
                   <p class="productPrice">
                       <span class="defaultPrice">£${variant.price}</span>
                       <span class="comparePrice">${
                         variant.compare_at_price > 0
                           ? `£${variant.compare_at_price}`
                           : ""
                       }</span>
                       <span class="youSave">
                           ${
                             Number(variant.compare_at_price) > Number(variant.price)
                               ? `You Save: £${(
                                   variant.compare_at_price - variant.price
                                 ).toFixed(2)}`
                               : ""
                           }
                       </span>
                   </p>
                   <div class="stockInfo">
                       ${stockInfoHTML}
                   </div>
                   <p class="productDetailsHeader">More details</p>
                   <div class="productDetails">
                       <p><span>Manufacturer</span><span>${query.manufacturer.toUpperCase()}</span></p>
                       <p><span>Years</span><span>${query.year[0]} - ${
      query.year[query.year.length - 1]
    }</span></p>
                       <p><span>Model</span><span>${query.model.toUpperCase()}</span></p>
                       <p><span>Engine</span><span>${capitalizeWords(
                         query.engine
                       )}</span></p>
                       ${
                         query.vehicleType
                           ? `<p><span>Vehicle Type</span><span>${query.vehicleType}</span></p>`
                           : ""
                       }
                       ${
                         query.hp
                           ? `<p><span>HP</span><span>${query.hp}</span></p>`
                           : ""
                       }
                       ${
                         query.articleCriteria
                           ? `<p><span>Article Criteria</span><span>${query.articleCriteria}</span></p>`
                           : ""
                       }
                       ${
                         query.articleInfo
                           ? `<p><span>Article Info</span><span>${query.articleInfo}</span></p>`
                           : ""
                       }
                       ${
                         query.suspension
                           ? `<p><span>Suspension</span><span>${query.suspension}</span></p>`
                           : ""
                       }
                       ${
                         query.suspensionFront
                           ? `<p><span>Suspension Front</span><span>${query.suspensionFront}</span></p>`
                           : ""
                       }
                       ${
                         query.suspensionRear
                           ? `<p><span>Suspension Rear</span><span>${query.suspensionRear}</span></p>`
                           : ""
                       }
                       ${
                         query.loweredFront
                           ? `<p><span>Lowered Front</span><span>${query.loweredFront}</span></p>`
                           : ""
                       }
                       ${
                         query.loweredRear
                           ? `<p><span>Lowered Rear</span><span>${query.loweredRear}</span></p>`
                           : ""
                       }
                       ${
                         query.vinFrom
                           ? `<p><span>VIN From</span><span>${query.vinFrom}</span></p>`
                           : ""
                       }
                       ${
                         query.vinTo
                           ? `<p><span>VIN To</span><span>${query.vinTo}</span></p>`
                           : ""
                       }
                   </div>
               </div>
               
               <div class="addToCardWrapper">
                   <select id="quantitySelect_${variant.id}" >
                       ${quantityDropdownValues
                         .map(
                           (element) =>
                             `<option value="${element}">${element}</option>`
                         )
                         .join("")}
                   </select>
                   <div style="position:relative;width:100%">
                     ${addToCartButtonHTML}
                     <div class="loading__spinner hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                      </div>
                   </div>
               </div>
           </div>`;

    return productHTML;
  }

  // fetch sku and print product cards and run filter logic
  if (window.location.href.includes(pageUrl)) {
    // ---- Loading skeletons -------------------------------------------------
    // Shimmer placeholders shown while a search is in flight; they are replaced
    // the moment the real filter options / product cards render.
    function skeletonCards(count) {
      let s = "";
      for (let i = 0; i < count; i++) {
        s += `<div class="appProduct skeletonCard">
                <div class="skeleton skeletonImg"></div>
                <div class="skeleton skeletonLine" style="width:70%"></div>
                <div class="skeleton skeletonLine" style="width:90%"></div>
                <div class="skeleton skeletonLine" style="width:40%"></div>
                <div class="skeleton skeletonBtn"></div>
              </div>`;
      }
      return s;
    }

    function skeletonFilterGroup() {
      let lines = "";
      for (let i = 0; i < 3; i++) {
        lines += `<li><span class="skeleton skeletonLine" style="width:80%;"></span></li>`;
      }
      return `<div class="filterOption">
                <div class="skeleton skeletonLine" style="width:45%;height:14px;margin-bottom:10px;"></div>
                <ul class="filterOptionContent open" style="display:block;">${lines}</ul>
              </div>`;
    }

    function showSearchLoading() {
      const filterClass = document.querySelector(".customFilter");
      if (filterClass) filterClass.classList.add("data-in");

      const csvW = document.querySelector(".csvFilterWrapper");
      const tagW = document.querySelector(".tagFilterWrapper");
      if (csvW) csvW.innerHTML = skeletonFilterGroup();
      if (tagW) tagW.innerHTML = skeletonFilterGroup();

      if (productInfo) {
        productInfo.classList.remove("noProductFound");
        productInfo.innerHTML = skeletonCards(6);
      }
    }

    function clearSearchLoading() {
      const csvW = document.querySelector(".csvFilterWrapper");
      const tagW = document.querySelector(".tagFilterWrapper");
      if (csvW) csvW.innerHTML = "";
      if (tagW) tagW.innerHTML = "";
      if (productInfo) productInfo.innerHTML = "";
    }
    // ------------------------------------------------------------------------

    // Function to fetch SKUs based on the selected engine type
    function fetchSKUs(
      selectedManufacturer,
      selectedYear,
      selectedModel,
      selectedEngine
    ) {
      // Check if a engine type is selected
      if (selectedEngine) {
        // Show skeleton placeholders until the filters/products are ready.
        showSearchLoading();
        // manufacturer a request to the backend with the selected engine type value
        fetch(`/apps/bilstein-search-v2/csv-data-skus?manufacturer=${selectedManufacturer}&year=${selectedYear}&model=${selectedModel}&engine=${selectedEngine}`)
          .then((response) => response.json())
          .then((sku) => {
            let skuArr = [];
            let filterClass = document.querySelector(".customFilter");
            filterClass.classList.remove("data-in");
            filterClass.classList.add("data-in");
            for (let element of sku) {
              skuArr.push(element.sku);
            }
            // console.log("sku array ", skuArr);
            domProducts = [];
            // getting product data
            async function getData(skuArr) {
              try {
                const response = await fetch(
                  `/apps/bilstein-search-v2/get-products-by-skus`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      skus: skuArr,
                      manufacturer: selectedManufacturer,
                      year: selectedYear,
                      model: selectedModel,
                      engine: selectedEngine,
                    }),
                  }
                );
                const { products, csvDataResults } = await response.json();

                // Index products by variant SKU once so each row is an O(1)
                // lookup instead of re-scanning every product/variant per row.
                const productBySku = new Map();
                products.forEach((product) => {
                  product.variants.forEach((variant) => {
                    if (!productBySku.has(variant.sku)) {
                      productBySku.set(variant.sku, product);
                    }
                  });
                });
                csvDataResults.forEach((element) => {
                  const product = productBySku.get(element.partNo);
                  if (product) {
                    domProducts.push({ query: element, product });
                  }
                });
                filterChips.innerHTML = "";
                // Keep the skeletons visible until the real cards/filters are
                // ready; the render paths below replace them.
                if (domProducts.length > 0) {
                  const getTagArray = async () => {
                    try {
                      const response = await fetch(
                        `/apps/bilstein-search-v2/sorting-tags`,
                        {
                          method: "GET",
                        }
                      );
                      const data = await response.json();
                      const arr = data[0].sortTag.split(",");
                      return arr.map(item => item.trim());
                    } catch (error) {
                      console.log("error in getting sorting tags", error);
                    }
                  };
                  
                  // Get tagPriority as an array of priority tags, all lowercased for robustness
                  const tagPriority = (await getTagArray()).map(tag => tag.toLowerCase());
                  
                  function containsTag(tags, tagName) {
                    // tags: array of comma-separated tag strings
                    // tagName: single tag string, already lowercased from tagPriority
                    return tags.some(tagString => 
                      tagString
                        .split(',')
                        .map(t => t.trim().toLowerCase())
                        .includes(tagName)
                    );
                  }
                  
                  if (tagPriority) {
                    domProducts.sort((a, b) => {
                      // Find the index of the highest-priority tag each product has
                      const aPriority = tagPriority.findIndex(tag =>
                        containsTag(a.product.tags, tag)
                      );
                      const bPriority = tagPriority.findIndex(tag =>
                        containsTag(b.product.tags, tag)
                      );
                  
                      // If a product doesn't contain any of the priority tags, set its index to a large number to sort it last
                      const aIndex = aPriority === -1 ? Number.MAX_SAFE_INTEGER : aPriority;
                      const bIndex = bPriority === -1 ? Number.MAX_SAFE_INTEGER : bPriority;
                  
                      return aIndex - bIndex;
                    });
                  }

                  filterInitialise(domProducts);


                  productInfo.innerHTML = domProducts
                    .map((element) =>
                      element.product
                        ? productCard(
                            element.query.partNo,
                            element.product,
                            element.query,
                            productDefinedPositions,
                            productDefinedRanges
                          )
                        : ""
                    )
                    .join("");
                  showProducts();
                  moreDetailsAccordian();
                } else {
                  // No results: clear the product + filter skeletons.
                  productInfo.innerHTML = "";
                  productInfo.classList.add("noProductFound");
                  const csvW = document.querySelector(".csvFilterWrapper");
                  const tagW = document.querySelector(".tagFilterWrapper");
                  if (csvW) csvW.innerHTML = "";
                  if (tagW) tagW.innerHTML = "";
                }
              } catch (error) {
                console.error("Error fetching products:", error);
                clearSearchLoading();
              }
            }
            getData(skuArr);
          })
          .catch((error) => {
            console.error("Error fetching SKUs:", error);
            clearSearchLoading();
          });
      }
    }

    let showBtn = document.querySelector(".showBrakes");
    showBtn.addEventListener("click", function () {
      fetchSKUs(
        manufacturerSelect.value,
        yearSelect.value,
        modelSelect.value,
        engineSelect.value
      );
    });

    // run the logic when page is refresh with all filter values
    if (manufacturer && year && model && engine) {
      fetchSKUs(manufacturer, year, model, engine);
    }
  }

  // Family A: CSV-field-driven sidebar filters.
  // Add a { key, label } entry here and it renders as a checkbox group and
  // participates in filtering automatically. `key` must match a CSV/DB field
  // name present on each product's `query` object.
  const CSV_SIDEBAR_FILTERS = [
    { key: "vinFrom", label: "VIN From" },
    { key: "vinTo", label: "VIN To" },
  ];

  // filter logic
  function filterInitialise(domProducts) {
    // Collect the distinct values present in the current result set for each
    // configured CSV field (Family A) and for the product tags (Family B).
    const csvFilterValues = {};
    CSV_SIDEBAR_FILTERS.forEach((f) => (csvFilterValues[f.key] = new Set()));
    let tagArr = [];

    domProducts.forEach((element) => {
      if (!element.product) return;
      CSV_SIDEBAR_FILTERS.forEach((f) => {
        const val = element.query[f.key];
        if (Array.isArray(val)) {
          val.forEach((v) => {
            if (v !== "" && v != null) csvFilterValues[f.key].add(v);
          });
        } else if (val !== "" && val != null) {
          csvFilterValues[f.key].add(val);
        }
      });
      if (element.product.tags != "") {
        tagArr.push(...element.product.tags[0].split(", "));
      }
    });
    const tagSet = new Set(tagArr);

    // Render Family A option blocks from the config array.
    const csvFilterWrapper = document.querySelector(".csvFilterWrapper");
    if (csvFilterWrapper) {
      csvFilterWrapper.innerHTML = CSV_SIDEBAR_FILTERS.map((f) => {
        const options = [...csvFilterValues[f.key]]
          .map(
            (option) =>
              `<li><input type='checkbox' data-filter-key='${f.key}' value='${option}'>${option}</li>`
          )
          .join("");
        return `<div class="filterOption">
                  <p class="filterOptionHeader">${f.label}</p>
                  <ul class="filterOptionContent csv_filter_${f.key}">${options}</ul>
                </div>`;
      }).join("");
    }

    // Render Family B option groups dynamically from the admin categories.
    // Every category in filterQueryData becomes its own checkbox group; only
    // options whose value appears in the current result set's tags are shown.
    const tagCategories = Array.isArray(filterQueryData) ? filterQueryData : [];
    const tagFilterWrapper = document.querySelector(".tagFilterWrapper");
    if (tagFilterWrapper) {
      tagFilterWrapper.innerHTML = tagCategories
        .map((cat) => {
          const options = cat.options
            .filter((option) => tagSet.has(option.subCategory))
            .map((option) => {
              const label = option.labelImage
                ? `<img src="/apps/bilstein-search-v2${option.labelImage}" style="height:20px;">`
                : option.labelText && option.labelImage == null
                ? `<span class="labelBox" style="background-color:${option.labelBg}">${option.labelText}</span>`
                : `<span class="labelBox" style="background-color:${option.labelBg}"></span>`;
              return `<li class="flex py-2" style="justify-content:space-between;">
                        <div>
                          <input type="checkbox" data-tag-key="${cat.name}" value="${option.subCategory}">
                          ${option.subCategory}
                        </div>
                        ${label}
                      </li>`;
            })
            .join("");
          return `<div class="filterSelect">
                    <p class="filterOptionHeader">${cat.name}</p>
                    <ul class="filterOptionContent">${options}</ul>
                  </div>`;
        })
        .join("");
    }

    // Product-card badges: keep the full option lists for the Position / Range
    // categories when the admin defines them (consumed by productCard).
    productDefinedPositions = [];
    productDefinedRanges = [];
    tagCategories.forEach((cat) => {
      if (cat.name === "Position")
        productDefinedPositions = cat.options.map((o) => o.subCategory);
      if (cat.name === "Range")
        productDefinedRanges = cat.options.map((o) => o.subCategory);
    });

    // Open the tag (Family B) filter sections by default.
    $(".tagFilterWrapper .filterOptionContent").addClass("open").slideDown(100);

    // applying conditions according to filter selection
    // Family A: one array of checked values per configured CSV field, keyed by field key.
    const csvConditions = {};
    CSV_SIDEBAR_FILTERS.forEach((f) => (csvConditions[f.key] = []));

    // Family B: one array of checked values per admin category, keyed by name.
    const tagConditions = {};
    tagCategories.forEach((cat) => (tagConditions[cat.name] = []));

    const allFilterInputs = document.querySelectorAll(
      ".filterOptionContent input"
    );

    function updateFilterConditions(array, value, add) {
      if (add) {
        if (!array.includes(value)) {
          array.push(value);
        }
      } else {
        // Remove the value using filter to avoid using pop incorrectly
        array = array.filter((item) => item !== value);
      }
      return array; // Return the updated array
    }

    // filter checkbox onclick function
    allFilterInputs.forEach((inputBox) => {
      inputBox.addEventListener("change", function (event) {
        const csvKey = this.dataset.filterKey;
        const tagKey = this.dataset.tagKey;
        if (csvKey && csvConditions[csvKey]) {
          csvConditions[csvKey] = updateFilterConditions(
            csvConditions[csvKey],
            event.target.value,
            event.target.checked
          );
        } else if (tagKey && tagConditions[tagKey]) {
          tagConditions[tagKey] = updateFilterConditions(
            tagConditions[tagKey],
            event.target.value,
            event.target.checked
          );
        }

        let filteredResults = domProducts.filter((product) => {
          const tags =
            product &&
            product.product &&
            typeof product.product.tags !== "undefined"
              ? product.product.tags[0].split(", ")
              : "";

          // Check conditions with AND between groups, OR within each group.
          // Family A: match each checked value against its own CSV field only
          // (exact match, mirroring the tag filters). AND across fields, OR within.
          const meetsCsv = CSV_SIDEBAR_FILTERS.every((f) => {
            const conds = csvConditions[f.key];
            if (conds.length === 0) return true;
            const fieldVal = product.query[f.key];
            const values = Array.isArray(fieldVal)
              ? fieldVal.map((v) => String(v))
              : [String(fieldVal == null ? "" : fieldVal)];
            return conds.some((s) => values.includes(s));
          });

          // Family B: AND across each category, OR within a category.
          const meetsTags = tagCategories.every((cat) => {
            const conds = tagConditions[cat.name];
            return (
              conds.length === 0 ||
              conds.some((condition) => tags.includes(condition))
            );
          });

          return meetsCsv && meetsTags;
        });

        // console.log(filteredResults);

        let c =
          CSV_SIDEBAR_FILTERS.reduce(
            (sum, f) => sum + csvConditions[f.key].length,
            0
          ) +
          tagCategories.reduce(
            (sum, cat) => sum + tagConditions[cat.name].length,
            0
          );

        const renderCards = (list) => {
          productInfo.innerHTML = list
            .map((element) =>
              element.product
                ? productCard(
                    element.query.partNo,
                    element.product,
                    element.query,
                    productDefinedPositions,
                    productDefinedRanges
                  )
                : ""
            )
            .join("");
        };

        if (filteredResults.length > 0) {
          productInfo.classList.remove("noProductFound");
          renderCards(filteredResults);
          currentPage = 1;
          showProducts();
        } else if (filteredResults.length == 0 && c != 0) {
          productInfo.innerHTML = "";
          productInfo.classList.add("noProductFound");
          currentPage = 1;
          showProducts();
        } else {
          productInfo.classList.remove("noProductFound");
          renderCards(domProducts);
          currentPage = 1;
          showProducts();
        }
        $(".customFilter").removeClass("open");
      });
    });
  }

  // fetch tag filter headers and content wrapper from app
  const fetchfilter = async (afterSearch) => {
    const filter = document.querySelector(".tagFilterWrapper");
    if (filter) {
      filter.innerHTML = "";
      let str = "";

      fetch(`/apps/bilstein-search-v2/get-category`)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          filterQueryData = data;
          // let specificTag = filterQueryData.filter(item => item.name == 'Compound');
          // tagColors = specificTag[0].options; t
          // console.log('filterQueryData',filterQueryData)
          filterQueryData.forEach((element) => {
            if (afterSearch) {
              str += `<div class="filterSelect">
                               <p class="filterOptionHeader">${element.name}</p>
                               <ul class="filterOptionContent ${element.name.replace(
                                 " ",
                                 "_"
                               )}">
                                 ${element.options
                                   .map(
                                     (option) =>
                                       `<li class="flex py-2" style="justify-content:space-between;">
                                       <div>
                                         <input type="checkbox" value="${
                                           option.subCategory
                                         }">
                                         ${option.subCategory}
                                       </div>
                                       ${
                                         option.labelImage
                                           ? `<img src="/apps/bilstein-search-v2${option.labelImage}" style="height:20px;">`
                                           : option.labelText &&
                                             option.labelImage == null
                                           ? `<span class="labelBox" style="background-color:${option.labelBg}">${option.labelText}</span>`
                                           : `<span class="labelBox" style="background-color:${option.labelBg}"></span>`
                                       }
                                    </li>`
                                   )
                                   .join("")}
                               </ul>
                           </div>`;
            } else {
              str += `<div class="filterSelect">
                               <p class="filterOptionHeader">${element.name}</p>
                               <ul class="filterOptionContent ${element.name.replace(
                                 " ",
                                 "_"
                               )}"></ul>
                           </div>`;
            }
          });
          filter.innerHTML += str;
          filterAccordian();
        })
        .catch((error) => {
          console.error("Failed to fetch categories:", error);
        });
    }
  };
  fetchfilter();
});

// filter accordian
function filterAccordian() {
  // Delegated so it also covers headers rendered later (e.g. the CSV/Family A
  // sections built in filterInitialise). Namespaced + off to avoid duplicate
  // handlers when this runs more than once.
  $(document)
    .off("click.filterAccordian", ".filterOptionHeader")
    .on("click.filterAccordian", ".filterOptionHeader", function () {
      var content = $(this).next(".filterOptionContent");

      // If the clicked section is already open, close it
      if (content.hasClass("open")) {
        content.removeClass("open").slideUp(100);
      } else {
        // Open the clicked section
        content.addClass("open").slideDown(100);
      }
    });
}

if ($(window).width() < 900) {
  $(".mainFilterHeader").click(function () {
    const content = $(this).next(".productSearchWrapper");
    if (content.hasClass("open")) {
      content.removeClass("open").slideUp(100);
    } else {
      content.addClass("open").slideDown(100);
    }
  });

  $(".otherFilters").click(function () {
    const content = $(".customFilter");
    if (content.hasClass("open")) {
      content.removeClass("open");
    } else {
      content.addClass("open");
    }
  });

  $(".customFilter > h5").click(function () {
    $(".customFilter").removeClass("open");
  });
}

function moreDetailsAccordian() {
  if ($(window).width() < 900) {
    $(".productDetailsHeader").click(function () {
      const content = $(this).next(".productDetails");
      if (content.hasClass("open")) {
        content.removeClass("open").slideUp(100);
      } else {
        content.addClass("open").slideDown(100);
      }
    });
  }
}

document.addEventListener("change", function (event) {
  // Check if the changed element is one of our quantity selects
  // if (event.target && event.target.matches('select[id^="quantitySelect_"]')) {
  //     const nextSibling = event.target.closest('.addToCardWrapper').querySelector('button a');
  //     if (nextSibling) {
  //         let newQuantity = event.target.value;
  //         let newHref = nextSibling.href.replace(/quantity=\d+/, `quantity=${newQuantity}`);
  //         nextSibling.href = newHref;
  //     }
  // }
  moreDetailsAccordian();
  let arr = [];
  let c = document.querySelectorAll(".customFilter input");
  let currentFilter = document.querySelector(".currentFilter");

  for (let elem of c) {
    if (elem.checked) {
      arr.push(elem.value);
    }
  }

  if (currentFilter) {
    currentFilter.innerHTML = "";
  }

  arr.forEach((element) => {
    currentFilter.innerHTML += `<div>${element}
                                  <span onClick="removefilter(event)"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">
                                   <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                                   <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <rect width="24" height="24" fill="white"/> <path d="M7 17L16.8995 7.10051" stroke="#bfbfbf" stroke-linecap="round" stroke-linejoin="round"/> <path d="M7 7.00001L16.8995 16.8995" stroke="#bfbfbf" stroke-linecap="round" stroke-linejoin="round"/> </g>
                                   </svg>
                                  </span>
                                 </div>`;
  });
});

function removefilter(event) {
  let parentDiv = event.target.closest("div");
  let content = parentDiv.childNodes[0].textContent;
  let customFilterArr = document.querySelectorAll(".customFilter input");
  let result = Array.from(customFilterArr).filter(
    (element) => element.value.trim() == content.trim()
  );
  result.forEach((element) => {
    element.checked = false;
    element.dispatchEvent(new Event("change"));
  });
  parentDiv.remove();
}

// delivery timer
document.addEventListener("DOMContentLoaded", () => {
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return "th"; // Covers 4th - 20th
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  function isHoliday(date) {
    // const holidays = ["2025-03-28"];
    const holidays = ["2025-03-28", "2025-03-31"];
    const dateString =
      date.getFullYear() +
      "-" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    return holidays.includes(dateString);
  }

  // Built once, reused every tick — constructing Intl formatters is expensive
  // and updateCountdown runs every second.
  const ukTimeFormatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  const ukMonthFormatter = new Intl.DateTimeFormat("en-GB", { month: "short" });

  function getFixedUKTime() {
    const now = new Date();

    // Format the current date as a string in UK timezone
    const ukDateString = ukTimeFormatter.format(now);

    // Convert the string back to a Date object
    const dateParts = ukDateString.match(
      /(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2}):(\d{2})/
    );
    return new Date(
      `${dateParts[3]}-${dateParts[2]}-${dateParts[1]}T${dateParts[4]}:${dateParts[5]}:${dateParts[6]}`
    );
  }

  function getMonthName(date) {
    return ukMonthFormatter.format(date);
  }

  function updateCountdown() {
    var now = getFixedUKTime();
    // var now = new Date('2025-03-27T11:59:00');
    var targetTime = new Date(now.toISOString().split("T")[0]); // Resets to today's date at midnight.
    var deliveryDay; // This will store the date for delivery.

    // Handle specific scenarios for extended hours on weekends
    if (now.getDay() === 4 && now.getHours() >= 12) {
      // thrusday after 12 PM
      // Extend to Monday 12 PM
      targetTime.setDate(now.getDate() + 1);
      targetTime.setHours(10, 30, 0, 0);
      deliveryDay = new Date(targetTime.getTime());
      deliveryDay.setDate(deliveryDay.getDate() + 3);
    } else if (now.getDay() === 5) {
      // Friday after 12 PM
      // Extend to Monday 12 PM
      if (
        now.getHours() < 10 ||
        (now.getHours() == 10 && now.getMinutes() < 30)
      ) {
        targetTime.setDate(now.getDate());
        targetTime.setHours(10, 30, 0, 0);
        deliveryDay = new Date(targetTime.getTime());
        deliveryDay.setDate(deliveryDay.getDate() + 3);
      } else {
        targetTime.setDate(now.getDate() + 3);
        targetTime.setHours(12, 0, 0, 0);
        deliveryDay = new Date(targetTime.getTime());
        deliveryDay.setDate(deliveryDay.getDate() + 1);
      }
    } else if (now.getDay() === 6) {
      // Saturday
      targetTime.setDate(now.getDate() + 2);
      targetTime.setHours(12, 0, 0, 0);
      deliveryDay = new Date(targetTime.getTime());
      deliveryDay.setDate(deliveryDay.getDate() + 1);
    } else if (now.getDay() === 0) {
      // Saturday
      targetTime.setDate(now.getDate() + 1);
      targetTime.setHours(12, 0, 0, 0);
      deliveryDay = new Date(targetTime.getTime());
      deliveryDay.setDate(deliveryDay.getDate() + 1);
    } else {
      if (now.getHours() < 12) {
        // If it's before 12 PM, countdown to today's 12 PM, delivery tomorrow.
        targetTime.setHours(12, 0, 0, 0); // Set target time to today's noon.
        deliveryDay = new Date(targetTime.getTime());
        deliveryDay.setDate(deliveryDay.getDate() + 1); // Delivery tomorrow.
      } else {
        // If it's after 12 PM, countdown to tomorrow's 12 PM, delivery the day after tomorrow.
        targetTime.setDate(targetTime.getDate() + 1); // Move to tomorrow.
        targetTime.setHours(12, 0, 0, 0); // Set target time to noon.
        deliveryDay = new Date(targetTime.getTime());
        deliveryDay.setDate(deliveryDay.getDate() + 1); // Delivery the day after tomorrow.
      }
    }

    // Avoid Sundays and holidays for the delivery day

    while (isHoliday(deliveryDay)) {
      if (deliveryDay.getDay() == 5) {
        if (isHoliday(deliveryDay)) {
          targetTime.setDate(targetTime.getDate() + 1);
          targetTime.setHours(10, 30, 0, 0);
        }
        deliveryDay.setDate(deliveryDay.getDate() + 3);
      } else if (deliveryDay.getDay() == 1) {
        if (isHoliday(deliveryDay)) {
          targetTime.setDate(targetTime.getDate() + 3);
          targetTime.setHours(12, 0, 0, 0);
        }
        deliveryDay.setDate(deliveryDay.getDate() + 1);
      } else {
        if (isHoliday(deliveryDay)) {
          targetTime.setDate(targetTime.getDate() + 1);
        }
        deliveryDay.setDate(deliveryDay.getDate() + 1);
      }
    }

    // Formatting the dispatch date for display
    var dispatchText = document.querySelectorAll(".dispatch-text");
    var dayName = daysOfWeek[deliveryDay.getDay()];
    var dateWithSuffix =
      deliveryDay.getDate() + getOrdinalSuffix(deliveryDay.getDate());
    var monthName = getMonthName(deliveryDay);
    dispatchText.forEach((element) => {
      element.innerHTML = `for delivery ${dayName} ${dateWithSuffix} ${monthName}`;
    });

    // Calculate the time difference and update the countdown
    var timeDifference = targetTime - now;

    if (timeDifference > 0) {
      var hours = Math.floor(timeDifference / 3600000);
      var minutes = Math.floor((timeDifference % 3600000) / 60000);
      var seconds = Math.floor((timeDifference % 60000) / 1000);
      let countdownTimer = document.querySelectorAll(".countdown-timer");
      countdownTimer.forEach((element) => {
        element.innerHTML = `${hours}h ${minutes}m ${seconds}s`;
      });
    } else {
      var hours = Math.floor(timeDifference / 3600000);
      var minutes = Math.floor((timeDifference % 3600000) / 60000);
      var seconds = Math.floor((timeDifference % 60000) / 1000);
      let countdownTimer = document.querySelectorAll(".countdown-timer");
      countdownTimer.forEach((element) => {
        element.innerHTML = `${hours}h ${minutes}m ${seconds}s`;
      });
    }
  }

  setInterval(updateCountdown, 1000);
  updateCountdown(); // Initial call to start the countdown
});

// ebc search page pagination
const productsPerPage = 45;
let currentPage = 1;

function showProducts() {
  const products = document.querySelectorAll("#appProductWrapper .appProduct");
  const totalProducts = products.length;
  const totalPages = Math.ceil(totalProducts / productsPerPage);

  // Calculate the range of products to display
  const start = (currentPage - 1) * productsPerPage;
  const end = start + productsPerPage;
  products.forEach((product, index) => {
    product.style.display = index >= start && index < end ? "block" : "none";
  });

  updatePaginationDisplay(totalPages, totalProducts);
}

function updatePaginationDisplay(totalPages, totalProducts) {
  const paginationLinks = document.getElementById("paginationLinks");
  paginationLinks.innerHTML = ""; // Clear existing links

  // Define the range for the first pages and the last pages
  let startPages = 1;
  let endPages = totalPages;
  let showStartEllipsis = false;
  let showEndEllipsis = false;

  if (totalPages > 6) {
    // More complex pagination scenario
    if (currentPage > 4) {
      showStartEllipsis = true;
      startPages = Math.min(currentPage - 1, totalPages - 5);
    }

    if (currentPage < totalPages - 3) {
      showEndEllipsis = true;
      endPages = Math.max(currentPage + 1, 6);
    }
  }

  // Always show the first three pages
  for (let i = 1; i <= Math.min(3, totalPages); i++) {
    if (i < startPages) {
      paginationLinks.appendChild(createPageLink(i));
    }
  }

  // Show ellipses if necessary before middle pages
  if (showStartEllipsis) {
    paginationLinks.appendChild(createEllipses());
  }

  // Display middle pages if necessary
  for (let i = startPages; i <= endPages; i++) {
    paginationLinks.appendChild(createPageLink(i));
  }

  // Show ellipses if necessary before the last pages
  if (showEndEllipsis) {
    paginationLinks.appendChild(createEllipses());
  }

  // Always show the last three pages
  for (let i = Math.max(totalPages - 2, endPages + 1); i <= totalPages; i++) {
    paginationLinks.appendChild(createPageLink(i));
  }

  document.getElementById("productCount").textContent = `Showing ${Math.min(
    productsPerPage,
    totalProducts - (currentPage - 1) * productsPerPage
  )} of ${totalProducts} products`;
}

function createPageLink(page) {
  const link = document.createElement("button");
  link.textContent = page;
  link.onclick = function () {
    goToPage(page);
  };
  if (page === currentPage) {
    link.classList.add("currentPage");
  }
  return link;
}

function createEllipses() {
  const span = document.createElement("span");
  span.textContent = "...";
  return span;
}

function goToPage(pageNumber) {
  currentPage = pageNumber;
  showProducts();
}

function changePage(step) {
  const totalProducts = document.querySelectorAll(
    "#appProductWrapper .appProduct"
  ).length;
  const totalPages = Math.ceil(totalProducts / productsPerPage);
  currentPage += step;

  // Boundary check for pagination
  if (currentPage < 1) currentPage = 1;
  else if (currentPage > totalPages) currentPage = totalPages;

  showProducts();
}

// Event listeners for pagination buttons
let prevPage = document.getElementById("prevPage");
if (prevPage) {
  prevPage.addEventListener("click", () => changePage(-1));
}
let nextPage = document.getElementById("nextPage");
if (nextPage) {
  nextPage.addEventListener("click", () => changePage(1));
}

//-------- add to cart--------------//
function addToCart(variantId, event) {
  event.target.disabled = true;
  event.target.classList.add("loadingCart");
  event.target.nextElementSibling.classList.remove("hidden");
  let select = document.querySelector(`#quantitySelect_${variantId}`);
  let quantity = select.value;
  fetch(`/cart/add.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json(); // This parses the JSON body of the response
    })
    .then((data) => {
      updateCartBubble();
      // popup logic while click on collection page add-to-cart button.
      // updateCartNotification(data.key)

      // drawer logic while click on collection page add-to-cart button.
      updateCartDrawer();

      event.target.disabled = false;
      event.target.classList.remove("loadingCart");
      event.target.nextElementSibling.classList.add("hidden");
    })
    .catch((error) => {
      console.error("Error adding item to cart:", error.message);
    });
}

function updateCartBubble() {
  fetch(`/?section_id=cart-icon-bubble`)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newCartBubbleContent =
        doc.querySelector(".shopify-section").innerHTML;
      document.querySelector("#cart-icon-bubble").innerHTML =
        newCartBubbleContent;
    })
    .catch((err) => console.error("Failed to update cart bubble:", err));
}

function escapeCSS(id) {
  return id.replace(/([^\w-])/g, "\\$1");
}

function updateCartNotification(addedProductKey) {
  fetch(`/cart?sections=cart-notification-product`)
    .then((response) => response.text())
    .then((text) => {
      const json = JSON.parse(text);
      const html = json["cart-notification-product"];
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const escapedId = escapeCSS(
        `cart-notification-product-${addedProductKey}`
      );
      const newCartContent = doc.querySelector(`#${escapedId}`);
      if (newCartContent) {
        document.querySelector("#cart-notification-product").innerHTML =
          newCartContent.innerHTML;
        showCartNotification();
      }
    })
    .catch((error) =>
      console.error("Error updating cart notification product:", error)
    );

  fetch(`/cart?sections=cart-notification-button`)
    .then((response) => response.text())
    .then((text) => {
      const json = JSON.parse(text);
      const html = json["cart-notification-button"];
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newCartContent = doc.querySelector(`.shopify-section`);
      if (newCartContent) {
        document.querySelector("#cart-notification-button").innerHTML =
          newCartContent.innerHTML;
      }
    })
    .catch((error) =>
      console.error("Error updating cart notification button:", error)
    );
}

function showCartNotification() {
  const notification = document.querySelector("cart-notification");
  if (notification) {
    notification.open();
  }
}

const updateCartDrawer = async () => {
  await updateDrawer();
  openDrawer();
};

const updateDrawer = async () => {
  fetch(`/cart?sections=cart-drawer`)
    .then((response) => response.text())
    .then((text) => {
      const json = JSON.parse(text);
      const html = json["cart-drawer"];
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newCartDrawerContent = doc.querySelector("cart-drawer").innerHTML;
      document.querySelector("cart-drawer").innerHTML = newCartDrawerContent;
      document.querySelector("cart-drawer").classList.remove("is-empty");
    })
    .catch((err) => console.error("Failed to update cart drawer:", err));
};

const openDrawer = () => {
  const drawer = document.querySelector("cart-drawer");
  drawer && drawer.open();
};
